import { POLICY_MSG, policyError } from "@/lib/passwordPolicy";

export const MSG = {
    required: "Campo obbligatorio",
    piva: "Partita IVA non valida",
    email: "Inserisci un indirizzo email valido",
    password: POLICY_MSG,
    passwordMatch: "Le password non coincidono",
    privacy: "Devi accettare l'informativa privacy",
    url: "Inserisci un indirizzo web valido",
    phone: "Numero di telefono non valido",
};

const EMAIL_RE = /^[^@\s]+@[^@\s]+\.[A-Za-z]{2,}$/;
const URL_RE = /^(https?:\/\/)?([a-z0-9]([a-z0-9-]*[a-z0-9])?\.)+[a-z]{2,}(:\d{1,5})?(\/\S*)?$/i;
const PHONE_RE = /^\+?\d{6,15}$/;

export function validPiva(v) {
    if (!/^\d{11}$/.test(v)) return false;
    let sum = 0;
    for (let i = 0; i < 10; i += 1) {
        let d = Number(v[i]);
        if (i % 2 === 1) {
            d *= 2;
            if (d > 9) d -= 9;
        }
        sum += d;
    }
    return (10 - (sum % 10)) % 10 === Number(v[10]);
}

export const validPassword = (v, email = "") => !policyError(v, email);

function checkValidator(name, value, values) {
    if (name === "piva" && !validPiva(value.replace(/\s/g, ""))) return MSG.piva;
    if (name === "email" && !EMAIL_RE.test(value)) return MSG.email;
    if (name === "phone" && !PHONE_RE.test(value.replace(/\s/g, ""))) return MSG.phone;
    if (name === "url" && !URL_RE.test(value)) return MSG.url;
    if (name === "password") return policyError(value, values.email || "");
    if (name === "password_confirm" && value !== (values.password || "")) return MSG.passwordMatch;
    return null;
}

export function validateFields(fields, values) {
    const errors = {};
    fields.forEach((f) => {
        const value = values[f.key];
        if (f.type === "checkbox") {
            if (f.required && value !== true) errors[f.key] = f.key === "privacy" ? MSG.privacy : MSG.required;
            return;
        }
        const v = (value ?? "").toString().trim();
        if (!v) {
            if (f.required) errors[f.key] = MSG.required;
            return;
        }
        if (f.validator) {
            const err = checkValidator(f.validator, v, values);
            if (err) errors[f.key] = err;
        }
    });
    return errors;
}

export function spinsForProvince(spins, provincia) {
    return provincia ? spins.filter((s) => s.provinces.includes(provincia)) : [];
}

export function applySpinRules(spins, provincia) {
    const matches = spinsForProvince(spins, provincia);
    return matches.length === 1 ? matches[0].id : "";
}
